import {
  getService,
  getAxiosConfiguration,
  getServiceWithCallback,
  getServiceByConfig
} from '@services/axiosUtil.js';
import * as constant from '@services/Constants';

export const createSignUpConfirmService = (callbackSuccess, data, email) => {
  const pathParams = email
    ? `${constant.MEA_SERVER_CONFIGURATION.resource.signupConfirm}${data}/${email}`
    : `${constant.MEA_SERVER_CONFIGURATION.resource.signupConfirm}${data}`;
  const configuration = getAxiosConfiguration(pathParams);
  return getServiceWithCallback(configuration, callbackSuccess, callbackSuccess);
};

export const createGetAllCountries = async () => {
  return getService(constant.MEA_SERVER_CONFIGURATION.resource.countries);
};

export const createAttachmentDownloadService = (eventId, attachmentId, callBackError) => {
  let configuration = getAxiosConfiguration(
    constant.MEA_SERVER_CONFIGURATION.resource.customerEventsDownloadAttachments
      .replace(':eventId', eventId)
      .replace(':attachmentId', attachmentId),
    true,
    false
  );
  configuration.responseType = 'blob';
  return getServiceByConfig(configuration, callBackError);
};
